import React from 'react';
import { useAuth } from '@app/contexts/AuthContext';
import { Outlet } from 'react-router-dom'
import { Navigate } from 'react-router-dom';

/**
 * Protect children routes and prevent from them to be displayed if no relative roles
 * @param {*} allowedRoles - List of roles that are permitted to display
 * @returns 
 */
export default function ProtectedRoute({ allowedRoles }) {
    // Get the authentification datas from the context
    const auth = useAuth();
    allowedRoles = allowedRoles ? allowedRoles : [];
    
    let currentUserRoles = auth.roles;

    if (auth.isConnected && hasAllowedRoles(allowedRoles, currentUserRoles)) {
        return <Outlet />;
    } else {
        return (      
            <Navigate to="/sign-in" replace={true} />
        )
    }
};

function hasAllowedRoles(allowedRoles, currentUserRoles) {    
    return ( 
        allowedRoles.some(role => currentUserRoles.findIndex((currentRole) => currentRole.role == role) > -1) ||
        allowedRoles.includes("all")
    );
}
